import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getHotComics } from '@/mocks/comics';

export default function HotSection() {
  const hotComics = getHotComics();

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门韩漫
          </h2>
          <p className="text-sm text-foreground-500 mt-1">万人追更的人气作品</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}